export default {
  autocompleteMinChars: 1,
  autocompleteMaxItems: 10,
  minSearchResults: 2,
  maxSearchResults: 20,
};
